import { Container as MuiContainer, ContainerProps } from '@mui/material';
import React from 'react';

export const Container = ({ maxWidth = 'xl', children, ...props }: ContainerProps) => {
    return (
        <MuiContainer maxWidth={maxWidth} {...props}>
            {children}
        </MuiContainer>
    );
};
